import { useNavigate } from 'react-router-dom';
import './product.css';

export default function ProductSection() {
    const navigate = useNavigate();

    return (
        <section className="w-full max-w-7xl mt-[30px] pb-[40px] sm:pb-[150px] [@media(max-width:340px)]:pb-[60px] ">
            <h1
                style={{ fontFamily: "myFirstFont" }}
                className="text-[35px] [@media(max-width:340px)]:pl-4 pl-8 sm:pl-[55px] sm:mb-[60px] mt-3 sm:text-[45px] md:text-[60px] leading-[1] z-10 text-white"
            >
                Our Products
            </h1>

            <div className="flex flex-col justify-center items-center sm:flex-row gap-6 mt-6 flex-wrap">

                {/* Personal Loan */}
                <div className="relative flex justify-center items-center bg-gradient-to-tr from-[#FFF200] via-[#FF7300] to-[#FF00AA] 
                    [@media(max-width:320px)]:h-[280px] [@media(max-width:320px)]:w-[280px]
                    [@media(max-width:340px)]:h-[300px] [@media(max-width:340px)]:w-[300px]
                    h-[330px] w-[330px] sm:h-[350px] sm:w-[350px] md:h-[370px] md:w-[370px] 
                    cursor-pointer transition-all duration-100 rounded-lg gradient-shadow"
                    onClick={() => navigate('/wip/personal-loan')}
                >
                    <div className="flex flex-col justify-between p-4 
                        [@media(max-width:320px)]:w-[276px] [@media(max-width:320px)]:h-[276px]
                        [@media(max-width:340px)]:w-[296px] [@media(max-width:340px)]:h-[296px]
                        w-[326px] h-[326px] sm:w-[346px] sm:h-[346px] md:w-[366px] md:h-[366px] 
                        rounded-lg bg-[#000000]">
                        <img src="/assets/img/Banknote.png" alt="Banknote" className="w-[41px] h-[30px] sm:w-[42px] sm:h-[32px] mb-4" />
                        <div>
                            <h3 style={{ fontFamily: 'myFirstFont7' }} className="text-[30px] font-semibold mb-2 text-white">Personal Loan</h3>
                            <p style={{ fontFamily: 'Atkinson-regular', lineHeight: 1.1 }} className="text-gray-500 w-[235px] text-[18px] [@media(max-width:320px)]:text-[15px]">
                                Get upto 20 Lacs in Personal Loan. Instant Approval. Quick Disbursal
                            </p>
                        </div>
                    </div>
                </div>

                {/* Business Loan */}
                <div className="relative flex justify-center items-center bg-gradient-to-tr from-[#500DCE] via-[#CEA0CE] to-[#EB6FE2]
                    [@media(max-width:320px)]:h-[280px] [@media(max-width:320px)]:w-[280px]
                    [@media(max-width:340px)]:h-[300px] [@media(max-width:340px)]:w-[300px]
                    h-[330px] w-[330px] sm:h-[350px] sm:w-[350px] md:h-[370px] md:w-[370px] 
                    rounded-lg gradient-shadow-blue cursor-pointer"
                    onClick={() => navigate('/wip/business-loan')}
                >
                    <div className="flex flex-col justify-between p-4 
                        [@media(max-width:320px)]:w-[276px] [@media(max-width:320px)]:h-[276px]
                        [@media(max-width:340px)]:w-[296px] [@media(max-width:340px)]:h-[296px]
                        w-[326px] h-[326px] sm:w-[346px] sm:h-[346px] md:w-[366px] md:h-[366px] 
                        rounded-lg bg-[#000000]">
                        <img src="/assets/img/Portfolio.png" alt="Portfolio" className="w-[41px] h-[30px] sm:w-[42px] sm:h-[32px] mb-4" />
                        <div>
                            <h3 style={{ fontFamily: 'myFirstFont7' }} className="text-[30px] font-semibold mb-2 text-white">Business Loan</h3>
                            <p style={{ fontFamily: 'Atkinson-regular', lineHeight: 1.1 }} className="text-gray-500 w-[235px] text-[18px] [@media(max-width:320px)]:text-[15px]">
                                Get upto 1 Cr in Business Loan. Quick approvals. No collateral.
                            </p>
                        </div>
                    </div>
                </div>

                {/* PayOff */}
                <div className="relative flex justify-center items-center bg-gradient-to-tr from-[#6E80B0] via-[#8CBEB2] to-[#CDD7AA] 
                    [@media(max-width:320px)]:h-[280px] [@media(max-width:320px)]:w-[280px]
                    [@media(max-width:340px)]:h-[300px] [@media(max-width:340px)]:w-[300px]
                    h-[330px] w-[330px] sm:h-[350px] sm:w-[350px] md:h-[370px] md:w-[370px] 
                    rounded-lg gradient-shadow-red cursor-pointer"
                    onClick={() => window.location.href = 'https://payoff.club/'}
                >
                    <div className="flex flex-col justify-between p-4 
                        [@media(max-width:320px)]:w-[276px] [@media(max-width:320px)]:h-[276px]
                        [@media(max-width:340px)]:w-[296px] [@media(max-width:340px)]:h-[296px]
                        w-[326px] h-[326px] sm:w-[346px] sm:h-[346px] md:w-[366px] md:h-[366px] 
                        rounded-lg bg-[#000000]">
                        <img src="/assets/img/Credit_Card.png" alt="Credit Card" className="w-[41px] h-[30px] sm:w-[42px] sm:h-[32px] mb-4" />
                        <div>
                            <h3 style={{ fontFamily: 'myFirstFont7' }} className="text-[30px] font-semibold mb-2 text-white">PayOff</h3>
                            <p style={{ fontFamily: 'Atkinson-regular', lineHeight: 1.1 }} className="text-gray-500 w-[235px] text-[18px] [@media(max-width:320px)]:text-[15px]">
                                Break-free from Credit Card debt trap. Lower Interest rates. Single EMI.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
